import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";

const data = [
  { name: "week-1", investors: 1400 },
  { name: "week-2", investors: 1400 },
  { name: "week-3", investors: 4500 },
  { name: "week-4", investors: 2000 },
  { name: "week-5", investors: 2000 },
  { name: "week-6", investors: 3800 },
  { name: "week-7", investors: 3800 },
];

const InvestorChart = ({ heading, graphData = [] }) => {
  const yAxisTicks = Array.from({ length: 6 }, (_, i) => i * 1000);

  console.log("graphData", graphData);
  return (
    <div style={{ width: "100%", minHeight: 350 }}>
      <h3
        style={{
          textAlign: "left",
          marginLeft: "20px",
          marginBottom: "20px",
          fontSize: window.innerWidth < 768 ? "14px" : "16px",
        }}
      >
        {heading}
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={graphData}
          margin={{ top: 20, right: 30, left: 20, bottom: 70 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            angle={-90}
            textAnchor="end"
            dx={-5}
            dy={10}
            tick={{ fontSize: window.innerWidth < 768 ? 10 : 12 }}
          />
          <YAxis
            ticks={yAxisTicks}
            dx={-10}
            domain={[0, 5000]}
            tick={{ fontSize: window.innerWidth < 768 ? 10 : 12 }}
          />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="investors"
            stroke="#035C98"
            activeDot={{ r: 8 }}
            dot={{ fill: "orange", stroke: "#035C98", strokeWidth: 2, r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default InvestorChart;
